import React from 'react';

const ShimmerLoader = ({ width = 'w-20', height = 'h-4' }) => {
  return (
    <div 
      className={`
        ${width} ${height} 
        loading-shimmer
        rounded-md
      `}
    />
  );
};

export default ShimmerLoader; 